import { createMuiTheme } from "@material-ui/core";

import palette from "./palette";

export default createMuiTheme({
  palette: {
    ...palette,
  },
});
